import { render, staticRenderFns } from "./OverlayAdditionalProducts.vue?vue&type=template&id=07a723d6&"
import script from "./OverlayAdditionalProducts.vue?vue&type=script&lang=js&"
export * from "./OverlayAdditionalProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/madamesumcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07a723d6')) {
      api.createRecord('07a723d6', component.options)
    } else {
      api.reload('07a723d6', component.options)
    }
    module.hot.accept("./OverlayAdditionalProducts.vue?vue&type=template&id=07a723d6&", function () {
      api.rerender('07a723d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/madamesum/js/pages/OverlayAdditionalProducts.vue"
export default component.exports